module.exports = __webpack_public_path__ + "c5a6823f4a3f4bd4ab0edab503bf7e4b.svg";